import { AppAlert } from '@components/antd';
import { useModal } from '@shared/hooks/use-modal';
import { capitalizeFirst } from '@shared/utils/capitalize';
import { useTranslation } from 'react-i18next';
import NotificationPermissionModal from '../../modal/modal-notification-permission';

export const NotificationSilentBanner = () => {
  const { open, handleOpen, handleClose } = useModal();
  const { t } = useTranslation();
  return (
    <>
      <AppAlert
        showIcon
        type="warning"
        message={
          <p>
            {t('notifications_browser_disabled')}{' '}
            <span className="cursor-pointer text-amber-700" onClick={handleOpen}>
              {capitalizeFirst(t('learn_more')) + '.'}
            </span>
          </p>
        }
      />
      <NotificationPermissionModal open={open} onClose={handleClose} />
    </>
  );
};
